import { render, staticRenderFns } from "./contentElementAdvicePrint.vue?vue&type=template&id=cf889b58&scoped=true"
import script from "./contentElementAdvicePrint.vue?vue&type=script&lang=js"
export * from "./contentElementAdvicePrint.vue?vue&type=script&lang=js"
import style0 from "./contentElementAdvicePrint.vue?vue&type=style&index=0&id=cf889b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf889b58",
  null
  
)

export default component.exports